/**
 * Wire channel suffix used by {@link buildRealtimeEventName}.
 */
export enum RealtimeChannelEnum {
  /** Record create, update, or delete events. */
  RECORD = 'record',
  /** Record status change events. */
  STATUS = 'record-status',
  /** Record availability change events. */
  AVAILABILITY = 'record-availability',
  /** Per-subscriber list filter opinions. */
  LIST = 'list',
  /** Per-user settings change events. */
  SETTINGS = 'settings',
}
